'use client';

import type {SxProps, Theme} from '@mui/material/styles';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {downloadFileFromUrl} from '../../shared/utils/download-file';
import {Button} from '../primitives';

export interface DownloadBrochureButtonProps {
  url: string;
  name: string;
  onDownload?: () => void;
  sx?: SxProps<Theme>;
}

function brochureFilename(name: string): string {
  const slug = name
    .trim()
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, '-')
    .replace(/^-+|-+$/g, '');
  return slug ? `${slug}-brochure.pdf` : 'brochure.pdf';
}

export function DownloadBrochureButton({url, name, onDownload, sx}: DownloadBrochureButtonProps) {
  const {t} = useTranslation();
  const [downloading, setDownloading] = useState(false);

  const handleClick = () => {
    onDownload?.();
    setDownloading(true);
    void downloadFileFromUrl(url, brochureFilename(name)).finally(() => {
      setDownloading(false);
    });
  };

  return (
    <Button variant="outlined-dark" onClick={handleClick} loading={downloading} sx={sx}>
      {t('download_brochure')}
    </Button>
  );
}

DownloadBrochureButton.displayName = 'DownloadBrochureButton';
